import React from 'react';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import BookingTeaserSection from './BookingTeaserSection';
import StaffSection from './StaffSection';
import PaymentsSection from './PaymentsSection';
import CaseStudySection from './CaseStudySection';
import VisionSection from './VisionSection';
import BottomCtaSection from './BottomCtaSection';
import LandingLayout, { useLandingMeta } from './LandingLayout';
import { trackLandingEvent } from './analytics';

const PrelaunchPage = () => {
  useLandingMeta();

  return (
    <LandingLayout>
      <HeroSection
        onGetStarted={() => trackLandingEvent('hero_get_started_click')}
        onTalkToUs={() => trackLandingEvent('hero_talk_to_us_click')}
      />
      <ProblemSection />
      <BookingTeaserSection />
      <StaffSection />
      <PaymentsSection />
      <CaseStudySection />
      <VisionSection onTalkToUs={() => trackLandingEvent('vision_talk_to_us_click')} />
      <BottomCtaSection />
    </LandingLayout>
  );
};

export default PrelaunchPage;
